import { render } from "./VabeneGiftCardsPage.vue?vue&type=template&id=1caa1cd2&ts=true"
import script from "./VabeneGiftCardsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneGiftCardsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__